import { environment } from '../../../environments/environment';

export const URLConstants = {
  getUFOShipments: environment.API_BASE_URL + '/v1/hawb/getUFOShipments',
  updateUFOShipments: environment.API_BASE_URL + '/v1/hawb/updateUFOShipments',
  deleteHawb: environment.API_BASE_URL + '/v1/hawb/delete',
  getAccountDetails: environment.API_BASE_URL + '/v1/master/accounts/fetch',
  getCustomerDetails: environment.API_BASE_URL + '/v1/master/customer/fetch/',
  getCountryDetails: environment.API_BASE_URL + '/v1/master/lookup',
  getStateDetails: environment.API_BASE_URL + '/v1/master/locality/search/',
  saveHawbInformation: environment.API_BASE_URL + '/v1/hawb/create',
  updateHawbInformation: environment.API_BASE_URL + '/v1/hawb/update',
  getHawbDataById: environment.API_BASE_URL + '/v1/hawb/fetch/',
  getDeliveryAgentById: environment.API_BASE_URL + '/v1/hawb/account/',
  getMasterHawbData:
    environment.API_BASE_URL + '/v1/hawb/masterShipment/validate',
  overageValidateReference:
    environment.API_BASE_URL + '/v1/hawb/overage/validateReference',
  overageSearchReferences:
    environment.API_BASE_URL + '/v1/hawb/overage/searchReferences',
  getDeleteCommodityDataById:
    environment.API_BASE_URL + '/v1/hawb/commodities/delete',
  getSaveCommodityDataById:
    environment.API_BASE_URL + '/v1/hawb/commodities/add',
  getUpdateCommodityDataById:
    environment.API_BASE_URL + '/v1/hawb/commodities/update',
  blockUnblockHawb: environment.API_BASE_URL + '/v1/hawb/blockUnblock',
  addHawbNotes: environment.API_BASE_URL + '/v1/base/addNotes',
  addHawbAttachment: environment.API_BASE_URL + '/v1/hawb/addAttachments',
  addRoles: environment.API_BASE_URL + '/v1/base/roles/create',
  advanceHawbInformation: environment.API_BASE_URL + '/v1/hawb/advanceSearch',
  autoRating: environment.API_BASE_URL + '/v1/accountsReceivable/autoRate',
  autoRatingValidate:
    environment.API_BASE_URL + '/v1/accountsReceivable/autoRate/validate',
  unAutoRating: environment.API_BASE_URL + '/v1/accountsReceivable/unAutoRate',

  //Hawb Summary //
  getHawbList: environment.API_BASE_URL + '/v1/hawb/basicSearch',
  getHawbListMock: environment.MOCK_API_URL + '/assets/mock/hawbList.json',
  masterLookup: environment.API_BASE_URL + '/v1/master/lookup/',
  bulkBaggingPieces: environment.API_BASE_URL + '/v1/bag/bulkBagging/validate',
  validateBagExists: environment.API_BASE_URL + '/v1/bag/bagExt/validate',
  createBagForBulkBagging:
    environment.API_BASE_URL + '/v1/bag/bulkBagging/create',
  bulkGatewayValidate:
    environment.API_BASE_URL + '/v1/hawb/bulkGateway/validate',
  BulkGatewayShipments: environment.API_BASE_URL + '/v1/hawb/bulkGateway',

  //Hawb Information //
  getHawbInfoList: environment.API_BASE_URL + '/v1/hawb/search',
  getHawbInfoListMock: environment.MOCK_API_URL + '/assets/mock/hawbInfo.json',
  getHawbById: environment.API_BASE_URL + '/v1/hawb/fetch',
  uniqueHawbDataBulkEdit:
    environment.API_BASE_URL + '/v1/hawb/bulkedit/uniquedata/',
  updateBulkHawb: environment.API_BASE_URL + '/v1/hawb/bulkedit/update',
  validateGateway: environment.API_BASE_URL + '/v1/hawb/gateway/validate',
  gatewayShipment: environment.API_BASE_URL + '/v1/hawb/gateway',

  multiPieceGateway: environment.API_BASE_URL + '/v1/hawb/gateway/multi-piece',
  accountServiceType: environment.API_BASE_URL + '/v1/hawb/fetchServiceType/',
  accountConfiguredServiceTypes:
    environment.API_BASE_URL + '/v1/hawb/account/',

  // Bag Summary //
  getBagList: environment.API_BASE_URL + '/v1/bag/search',
  getBagBasicList: environment.API_BASE_URL + '/v1/bag/basicSearch',

  // Bag Gateway
  validateBagOrManifestExt:
    environment.API_BASE_URL + '/v1/bag/container/validateBagOrManifesExt',
  bagGateway: environment.API_BASE_URL + '/v1/bag/container/gateway',
  createOutGoingBag:
    environment.API_BASE_URL + '/v1/bag/container/createOutgoingBag',
  createOutGoingManifest:
    environment.API_BASE_URL + '/v1/bag/container/createOutgoingManifest',
  // Bag Information //
  checkBagExt: environment.API_BASE_URL + '/v1/bag/fetch/',
  getShipmentData: environment.API_BASE_URL + '/v1/bag/getShipments',
  saveBagData: environment.API_BASE_URL + '/v1/bag/create',
  updateBagData: environment.API_BASE_URL + '/v1/bag/update',
  deleteBag: environment.API_BASE_URL + '/v1/bag/delete',
  deleteBagShipment: environment.API_BASE_URL + '/v1/bag/shipment/delete',
  createBagShipment: environment.API_BASE_URL + '/v1/bag/shipment/create',
  uniqueBagDataBulkEdit:
    environment.API_BASE_URL + '/v1/bag/bulkedit/uniquedata/',
  updateBulkBag: environment.API_BASE_URL + '/v1/bag/bulkedit/update',
  advanceBagInformation: environment.API_BASE_URL + '/v1/bag/advanceSearch',

  // Common Lookup's //
  requestType: environment.API_BASE_URL + '/v1/master/lookup/',
  generateNumber: environment.API_BASE_URL + '/v1/base/generateNumber',
  getStatusDropdownBasedOnModule:
    environment.API_BASE_URL + '/v1/base/getStatusCodeDescription',
  masterLookupType: environment.API_BASE_URL + '/v1/master/masterLookUp/',
  getRateScalesBasedOnAgents:
    environment.API_BASE_URL + '/v1/master/agentRateScales/',
  // Manifest Summary
  getManifestList: environment.API_BASE_URL + '/v1/manifest/search',
  getManifestSearchList: environment.API_BASE_URL + '/v1/manifest/basicSearch',
  deleteManifest: environment.API_BASE_URL + '/v1/manifest/delete',
  getManifestById: environment.API_BASE_URL + '/v1/manifest/fetch/',
  getManifestByManIds: environment.API_BASE_URL + '/v1/manifest/fetch/manIds/',
  uniqueDataBulkEdit:
    environment.API_BASE_URL + '/v1/manifest/bulkedit/uniquedata/',
  publishManifest: environment.API_BASE_URL + '/v1/manifest/publish',
  publishManifestEmail: environment.API_BASE_URL + '/v1/manifest/publish/email',
  getManifestPublishFormats: environment.API_BASE_URL + '/v1/manifest/formats',

  // Manifest Information
  getBagsForManifest: environment.API_BASE_URL + '/v1/manifest/getBag',
  createManifest: environment.API_BASE_URL + '/v1/manifest/create',
  updateManifest: environment.API_BASE_URL + '/v1/manifest/update',
  deleteManifestBags: environment.API_BASE_URL + '/v1/manifest/bags/delete',
  createManifestBag: environment.API_BASE_URL + '/v1/manifest/bags/add',
  updateBulkManifest: environment.API_BASE_URL + '/v1/manifest/bulkedit/update',
  advanceManifestInformation:
    environment.API_BASE_URL + '/v1/manifest/advanceSearch',
  // Bulk Manifesting
  bulkManifestValidate:
    environment.API_BASE_URL + '/v1/manifest/bulkManifest/validate',
  bulkManifestNumberValidate:
    environment.API_BASE_URL + '/v1/manifest/manifestNumber/validate',
  createBulkManifest:
    environment.API_BASE_URL + '/v1/manifest/bulkManifest/create',
  downloadHeldReportUrl:
    environment.API_BASE_URL + '/v1/manifest/getHeldReport/',
  // Attachment
  signedurl: environment.API_BASE_URL + '/v1/attachment/getSignedUrl',
  signedFullManurl:
    environment.API_BASE_URL + '/v1/attachment/fullmanFile/upload',
  downloadAttachment: environment.API_BASE_URL + '/v1/attachment/download',
  fullmanFileDownload:
    environment.API_BASE_URL + '/v1/attachment/fullmanFile/download',
  deleteAttachment: environment.API_BASE_URL + '/v1/attachment/delete',
  addAttachment: environment.API_BASE_URL + '/v1/attachment/create',
  // Mawb
  checkMawbExists: environment.API_BASE_URL + '/v1/mawb/validate',

  // Flight
  checkFlightExists: environment.API_BASE_URL + '/v1/flight/validate',

  // Mawb Information //
  checkMawbExt: environment.API_BASE_URL + '/v1/mawb/fetch/',
  getCbpEntryNumbers: environment.API_BASE_URL + '/v1/mawb/getEntryNumbers/',
  getManifestData: environment.API_BASE_URL + '/v1/manifest/getManifest/manIds',
  saveMawbData: environment.API_BASE_URL + '/v1/mawb/create',
  updateMawbData: environment.API_BASE_URL + '/v1/mawb/update',
  deleteMawbManifests: environment.API_BASE_URL + '/v1/mawb/deleteManifest',
  addMawbManifests: environment.API_BASE_URL + '/v1/mawb/addManifest',
  deleteFlight: environment.API_BASE_URL + '/v1/mawb/flight/delete',
  getSaveFlightDataById: environment.API_BASE_URL + '/v1/mawb/flight/create',
  getUpdateFlightDataById: environment.API_BASE_URL + '/v1/mawb/flight/update',

  // pallets view mode
  saveViewModePallets: environment.API_BASE_URL + '/v1/mawb/pallets/create',
  updateViewPallets: environment.API_BASE_URL + '/v1/mawb/pallets/update',
  deleteViewPallets: environment.API_BASE_URL + '/v1/mawb/pallets/delete',

  // Mawb Summary
  getMawbList: environment.API_BASE_URL + '/v1/mawb/basicSearch',
  deleteMawb: environment.API_BASE_URL + '/v1/mawb/delete',
  publishMawb: environment.API_BASE_URL + '/v1/mawb/publish',
  fetchMatchedManifests:
    environment.API_BASE_URL + '/v1/mawb/getManifestMatchedCriteria',
  advanceMawbInformation: environment.API_BASE_URL + '/v1/mawb/advanceSearch',
  // Bulk MAWB
  bulkMAWBValidate: environment.API_BASE_URL + '/v1/mawb/bulkMawb/validate',
  bulkMawbNumberValidate:
    environment.API_BASE_URL + '/v1/mawb/mawbExt/validate',
  createBulkMAWB: environment.API_BASE_URL + '/v1/mawb/bulkmawb/create',
  // Setup & Maintanance - Accounts
  createAccount: environment.API_BASE_URL + '/v1/sm/account/create',
  updateAccount: environment.API_BASE_URL + '/v1/sm/account/update',
  accountSearch: environment.API_BASE_URL + '/v1/sm/account/search',
  validateAccount:
    environment.API_BASE_URL + '/v1/sm/account/validate/accountNumber/',
  autogenerateAccountNumber:
    environment.API_BASE_URL + '/v1/sm/account/autoGenerate',
  firstLinkedAccountNumber:
    environment.API_BASE_URL + '/v1/sm/account/createAccountAndUpdateShipment',
  deleteAccount: environment.API_BASE_URL + '/v1/sm/account/delete',

  // customer grid
  addOrUpdateCustomerGrid:
    environment.API_BASE_URL + '/v1/sm/account/customerService/createOrUpdate',
  deleteCustomerGrid:
    environment.API_BASE_URL + '/v1/sm/account/customerService/delete',
  addOrUpdateAccountRouting:
    environment.API_BASE_URL + '/v1/sm/account/routingCriteria/createOrUpdate',
  deleteAccountRouting:
    environment.API_BASE_URL + '/v1/sm/account/routingCriteria/delete',

  // Setup & Maintanance - Organization
  createOrganization: environment.API_BASE_URL + '/v1/sm/organization/add',
  updateOrganization: environment.API_BASE_URL + '/v1/sm/organization/update',
  fetchOrganization: environment.API_BASE_URL + '/v1/sm/organization/fetch/',
  deleteOrganization: environment.API_BASE_URL + '/v1/sm/organization/delete',
  validateOrganization:
    environment.API_BASE_URL + '/v1/sm/organization/validate/',

  // Basic Search
  saveUpdatePinSearch: environment.API_BASE_URL + '/v1/search/pinOrUnpin',
  getRecentAndPinnedSearchesList:
    environment.API_BASE_URL + '/v1/search/getRecent',
  getSavedSearchesList: environment.API_BASE_URL + '/v1/search/getSaved',
  saveUpdateNewSearch: environment.API_BASE_URL + '/v1/search/updateSaved',
  deleteSearch: environment.API_BASE_URL + '/v1/search/deleteSaved',

  //auth service
  authorize: environment.API_BASE_URL + '/v1/auth/authorize',
  ipAddress: 'https://api.ipify.org/?format=json',

  // Account
  checkAccountInfo: environment.API_BASE_URL + '/v1/sm/account/fetch/',
  fetchAccountById: environment.API_BASE_URL + '/v1/sm/account/fetch/accounts/',

  // User
  createUser: environment.API_BASE_URL + '/v1/sm/users/create ',
  updateUser: environment.API_BASE_URL + '/v1/sm/users/update ',
  deleteUser: environment.API_BASE_URL + '/v1/sm/users/delete',
  fetchUser: environment.API_BASE_URL + '/v1/sm/users/fetch/',
  getDepartmentAndRole:
    environment.API_BASE_URL + '/v1/sm/users/getDepartmentAndRoles',
  basicSearchUser: environment.API_BASE_URL + '/v1/sm/users/basicSearch',
  userLoginHistory: environment.API_BASE_URL + '/v1/sm/users/getLoginHistory/',
  sendEmail: environment.API_BASE_URL + '/v1/sm/users/sendEMail',

  // User - departments
  addOrUpdateDepartment:
    environment.API_BASE_URL + '/v1/sm/users/department/createOrUpdate',
  deleteDepartment: environment.API_BASE_URL + '/v1/sm/users/department/delete',

  // Roles & PErmissions
  getRoleAndPermissionData:
    environment.API_BASE_URL + '/v1/sm/rolesAndPermissions/loadFields',
  createGroupDepartmentRole:
    environment.API_BASE_URL + '/v1/sm/rolesAndPermissions/create/',
  updateGroupDepartmentRole:
    environment.API_BASE_URL + '/v1/sm/rolesAndPermissions/update/',
  deleteGroupDepartmentRole:
    environment.API_BASE_URL + '/v1/sm/rolesAndPermissions/delete/',
  fetchGroupDepartmentRole:
    environment.API_BASE_URL + '/v1/sm/rolesAndPermissions/fetch/',
  validateGroupDepartmentRole:
    environment.API_BASE_URL + '/v1/sm/rolesAndPermissions/validate/',
  createRolesPermissions:
    environment.API_BASE_URL + '/v1/sm/rolesAndPermissions/createOrUpdate',
  deleteRolesPermissions:
    environment.API_BASE_URL + '/v1/sm/rolesAndPermissions/delete',
  fetchRole: environment.API_BASE_URL + '/v1/sm/rolesAndPermissions/fetchData/',
  basicSearchRole:
    environment.API_BASE_URL + '/v1/sm/rolesAndPermissions/basicSearch',
  validateUserExistGrpDeptRole:
    environment.API_BASE_URL +
    '/v1/sm/rolesAndPermissions/validateUserExistDeptRoles/',
  loadEffectivePermissions:
    environment.API_BASE_URL +
    '/v1/sm/rolesAndPermissions/loadEffectivePermissions',

  //User Profile
  getUserProfileDetails:
    environment.API_BASE_URL + '/v1/sm/users/fetchUserProfile',
  updateUserProfileDetails:
    environment.API_BASE_URL + '/v1/sm/users/updateUserProfile',

  //SM - Status Codes
  basicSearchStatusCodes:
    environment.API_BASE_URL + '/v1/sm/statusCodes/basicSearch',
  addOrUpdateStatusCode:
    environment.API_BASE_URL + '/v1/sm/statusCodes/createOrUpdate',
  deleteStatusCode: environment.API_BASE_URL + '/v1/sm/statusCodes/delete',
  bulkPodStatusCode:
    environment.API_BASE_URL + '/v1/sm/statusCodes/bulkPod',
  // Manifest POD (SPEC-BPM-001): append `/{id}/shipments` or `/{id}/linkedShipments`
  manifestPod: environment.API_BASE_URL + '/v1/sm/statusCodes/manifestPod',
  // Status Codes View Mode
  createStatusCode: environment.API_BASE_URL + '/v1/base/statusCodes/create',
  updateStatusCode: environment.API_BASE_URL + '/v1/base/statusCodes/update',
  deleteViewStatusCode:
    environment.API_BASE_URL + '/v1/base/statusCodes/delete',
  // Number Range
  createUpdateNumberRange:
    environment.API_BASE_URL + '/v1/sm/numberRange/createOrUpdate',
  numberRangeSearch:
    environment.API_BASE_URL + '/v1/sm/numberRange/basicSearch',
  deleteNumberRange: environment.API_BASE_URL + '/v1/sm/numberRange/delete',

  // Fullman files + Customs City grids (Shipment Clearance Status)
  fetchFullmanFiles:
    environment.API_BASE_URL + '/v1/sm/testfullmanFile/fetchFullmanFileData',
  fetchCustomsCityDraftData:
    environment.API_BASE_URL + '/v1/customsCity/fetchCustomsCityDraftData',
  fetchCustomsCityABIData:
    environment.API_BASE_URL + '/v1/customsCity/fetchCustomsCityABIData',
  // LEGACY CBP grids — rollback only
  // fetchCbpRequestStatus: environment.API_BASE_URL + '/v1/sm/testfullmanFile/fetchCBPRequestData',
  // fetchCbpResponseStatus: environment.API_BASE_URL + '/v1/sm/testfullmanFile/fetchCBPResponseData',
  // Send CBP Response — legacy CBP (routes commented on Node; kept for rollback)
  validateCBP: environment.API_BASE_URL + '/v1/base/cbpClearance/validate',
  clearanceCBP: environment.API_BASE_URL + '/v1/base/sendCbpClearance',
  processCustomsCityClearance:
    environment.API_BASE_URL + '/v1/customsCity/processClearance',
  validateClearanceSelection:
    environment.API_BASE_URL + '/v1/customsCity/validateClearanceSelection',
  validateCustomsCityClearance:
    environment.API_BASE_URL + '/v1/customsCity/validateCustomsCityClearance',
  simulateCcityHolds:
    environment.API_BASE_URL + '/v1/customsCity/simulate/holds',

  // Service Types API endpoints
  serviceTypeBasicSearch:
    environment.API_BASE_URL + '/v1/sm/serviceType/basicSearch',
  addServiceType: environment.API_BASE_URL + '/v1/sm/serviceType/create',
  updateServiceType: (serviceType: string) =>
    environment.API_BASE_URL + '/v1/sm/serviceType/update/' + serviceType,
  deleteServiceType: (serviceType: string) =>
    environment.API_BASE_URL + '/v1/sm/serviceType/delete/' + serviceType,

  /* Agents URL */
  agents: {
    search: environment.API_BASE_URL + '/v1/sm/agent/basicSearch',
    getById: environment.API_BASE_URL + '/v1/sm/agent/fetch/agentId',
    create: environment.API_BASE_URL + '/v1/sm/agent/create',
    update: environment.API_BASE_URL + '/v1/sm/agent/update',
    delete: environment.API_BASE_URL + '/v1/sm/agent/delete',
  },

  /* Routing URL */
  routing: {
    search: environment.API_BASE_URL + '/v1/sm/routing/basicSearch',
    delete: environment.API_BASE_URL + '/v1/sm/routing/delete',
    // New endpoints for Add Route feature
    getById: environment.API_BASE_URL + '/v1/sm/routing/fetch/',
    create: environment.API_BASE_URL + '/v1/sm/routing/create',
    update: environment.API_BASE_URL + '/v1/sm/routing/update',
    getWarehouses: environment.API_BASE_URL + '/v1/master/lookup/ibcWarehouses',
    getAirlines: environment.API_BASE_URL + '/v1/master/lookup/airlineCode',
    validateDuplicate:
      environment.API_BASE_URL + '/v1/sm/routing/validateDuplicate',
    // View Route feature endpoints
    deleteRoute: environment.API_BASE_URL + '/v1/sm/routing/route/delete',
    getShipmentRoutes: environment.API_BASE_URL + '/v1/sm/routing/forShipment',
  },

  /* HAWB Route URL */
  createHawbRoute: environment.API_BASE_URL + '/v1/hawb/route/create',
  bulkRouteValidate: environment.API_BASE_URL + '/v1/hawb/route/bulk/validate',
  bulkRouteApply: environment.API_BASE_URL + '/v1/hawb/route/bulk',
  fetchHawbRoute: environment.API_BASE_URL + '/v1/hawb/route/fetch/',
  addTransitPoint:
    environment.API_BASE_URL + '/v1/hawb/route/transitPoints/add',
  editTransitPoint:
    environment.API_BASE_URL + '/v1/hawb/route/transitPoints/edit',
  deleteTransitPoint:
    environment.API_BASE_URL + '/v1/hawb/route/transitPoints/delete',

  // Fetch Events
  getEventAllList: environment.API_BASE_URL + '/v1/base/getEvents',

  // Airports URL
  createAirport: environment.API_BASE_URL + '/v1/sm/airport/create',
  updateAirport: environment.API_BASE_URL + '/v1/sm/airport/update',
  airportBasicSearch: environment.API_BASE_URL + '/v1/sm/airport/basicSearch',
  bulkDeleteAirports: environment.API_BASE_URL + '/v1/sm/airport/bulk-delete',
  fetchAirport: environment.API_BASE_URL + '/v1/sm/airport/fetch/',
  airportDefaultInfo:
    environment.API_BASE_URL + '/v1/sm/airport/default-info/',

  /* HS code URLs */
  fetchHsCodeList: environment.API_BASE_URL + '/v1/sm/hsCodes/fetch/hsCodeId/',
  deleteHScode: environment.API_BASE_URL + '/v1/sm/hsCodes/delete',
  createHScode: environment.API_BASE_URL + '/v1/sm/hsCodes/create',
  upadetHScode: environment.API_BASE_URL + '/v1/sm/hsCodes/update',
  hsCodeBasicSearch: environment.API_BASE_URL + '/v1/sm/hsCodes/basicSearch',

  // Airline
  createAirline: environment.API_BASE_URL + '/v1/sm/airline/create',
  updateAirline: environment.API_BASE_URL + '/v1/sm/airline/update',
  airlineSearch: environment.API_BASE_URL + '/v1/sm/airline/basicSearch',
  deleteAirline: environment.API_BASE_URL + '/v1/sm/airline/delete',
  fetchAirline: environment.API_BASE_URL + '/v1/sm/airline/fetch/',

  // Cancel / Recover Shipments URLs
  cancelRecoverShipments: {
    search: environment.API_BASE_URL + '/v1/cancelRecoverShipments/search',
    validateUpload:
      environment.API_BASE_URL + '/v1/cancelRecoverShipments/validateUpload',
    cancel: environment.API_BASE_URL + '/v1/cancelRecoverShipments/cancel',
    recover: environment.API_BASE_URL + '/v1/cancelRecoverShipments/recover',
  },

  //Agent types URL
  agentTypes: {
    search: environment.API_BASE_URL + '/v1/sm/agentTypes/basicSearch',
    delete: environment.API_BASE_URL + '/v1/sm/agentTypes/delete',
    update: environment.API_BASE_URL + '/v1/sm/agentTypes/update',
    create: environment.API_BASE_URL + '/v1/sm/agentTypes/create',
  },

  serviceTypeGroups: {
    search: environment.API_BASE_URL + '/v1/sm/serviceTypeGroups/basicSearch',
    create: environment.API_BASE_URL + '/v1/sm/serviceTypeGroups/create',
    update: environment.API_BASE_URL + '/v1/sm/serviceTypeGroups/update',
    delete: environment.API_BASE_URL + '/v1/sm/serviceTypeGroups/delete',
  },
  // Clearance types
  clearacneTypesBasicSearch:
    environment.API_BASE_URL + '/v1/sm/clearanceTypes/basicSearch',
  addClearanceType: environment.API_BASE_URL + '/v1/sm/clearanceTypes/create',
  updateClearanceType:
    environment.API_BASE_URL + '/v1/sm/clearanceTypes/update',
  deleteClearanceType:
    environment.API_BASE_URL + '/v1/sm/clearanceTypes/delete',
  accountUsers: {
    createOrUpdate:
      environment.API_BASE_URL + '/v1/sm/account/users/createOrUpdate',
    delete: environment.API_BASE_URL + '/v1/sm/account/users/delete',
    resetPassword:
      environment.API_BASE_URL + '/v1/sm/account/users/resetPassword',
  },
  // Facility api's
  facilityBasicSearch:
    environment.API_BASE_URL + '/v1/sm/facilities/basicSearch',
  deleteFacilityById: environment.API_BASE_URL + '/v1/sm/facilities/delete',
  createFacility: environment.API_BASE_URL + '/v1/sm/facilities/create',
  fetchFacility: environment.API_BASE_URL + '/v1/sm/facilities/fetch/',
  editFacility: environment.API_BASE_URL + '/v1/sm/facilities/update',
  facilityDefaultInfo:
    environment.API_BASE_URL + '/v1/sm/facilities/default-info',
  facilityLookup: environment.API_BASE_URL + '/v1/master/lookup/facility',

  // Delivery Zones URL
  createDeliveryZone: environment.API_BASE_URL + '/v1/sm/deliveryZone/create',
  updateDeliveryZone: environment.API_BASE_URL + '/v1/sm/deliveryZone/update',
  deliveryZoneBasicSearch:
    environment.API_BASE_URL + '/v1/sm/deliveryZone/basicSearch',
  deleteDeliveryZoneById:
    environment.API_BASE_URL + '/v1/sm/deliveryZone/delete',
  fetchDeliveryZone: environment.API_BASE_URL + '/v1/sm/deliveryZone/fetch/',
  addDeliveryZoneGrid:
    environment.API_BASE_URL + '/v1/sm/deliveryZone/deliveryZone/create',
  editDeliveryZoneGrid:
    environment.API_BASE_URL + '/v1/sm/deliveryZone/deliveryZone/update',
  deleteDeliveryZoneGrid:
    environment.API_BASE_URL + '/v1/sm/deliveryZone/deliveryZone/delete',

  // Rate Scale URL
  rateScaleSearch: environment.API_BASE_URL + '/v1/sm/rateScale/basicSearch',
  rateScaleCreate: environment.API_BASE_URL + '/v1/sm/rateScale/create',
  fetchDeliveryZoneByAgentId:
    environment.API_BASE_URL + '/v1/sm/deliveryZone/fetch/zones/',
  deleteRateScales: environment.API_BASE_URL + '/v1/sm/rateScale/delete',
  fetchAPChargeCodebyAgentId:
    environment.API_BASE_URL + '/v1/sm/rateScale/fetchAPChargeCodes/',
  fetchAgentServicebyAgentId:
    environment.API_BASE_URL + '/v1/sm/rateScale/getAgentServiceType/',
  fetchRateScale: environment.API_BASE_URL + '/v1/sm/rateScale/fetch/',
  rateScaleupdate: environment.API_BASE_URL + '/v1/sm/rateScale/update',

  // IBC charge code URL
  ibcChargeCodeBasicSearch:
    environment.API_BASE_URL + '/v1/sm/ibcChargeCode/basicSearch',
  deleteIbcChargeCodeType:
    environment.API_BASE_URL + '/v1/sm/ibcChargeCode/delete',
  createIbcChargeCode: environment.API_BASE_URL + '/v1/sm/ibcChargeCode/create',
  updateIbcChargeCode: environment.API_BASE_URL + '/v1/sm/ibcChargeCode/update',

  // AP Charge Code
  apChargeCodeBasicSearch:
    environment.API_BASE_URL + '/v1/sm/apChargeCode/basicSearch',
  deleteAPChargeCodeType:
    environment.API_BASE_URL + '/v1/sm/apChargeCode/delete',
  createApChargeCode: environment.API_BASE_URL + '/v1/sm/apChargeCode/create',
  updateApChargeCode: environment.API_BASE_URL + '/v1/sm/apChargeCode/update',
  fetchApChargeCode: environment.API_BASE_URL + '/v1/sm/apChargeCode/fetch/',
  addApChargeCodeGrid:
    environment.API_BASE_URL + '/v1/sm/apChargeCode/apChargeCode/create',
  editApChargeCodeGrid:
    environment.API_BASE_URL + '/v1/sm/apChargeCode/apChargeCode/update',
  deleteApChargeCodeGrid:
    environment.API_BASE_URL + '/v1/sm/apChargeCode/apChargeCode/delete',
  createAgentChargeCode:
    environment.API_BASE_URL + '/v1/sm/apChargeCode/agentChargeCode/create',
  updateAgentChargeCode:
    environment.API_BASE_URL + '/v1/sm/apChargeCode/agentChargeCode/update',

  // Accounts Payable
  accountsPayableBasicSearch:
    environment.API_BASE_URL + '/v1/accountsPayable/basicSearch',
  deleteAccountsPayableType:
    environment.API_BASE_URL + '/v1/accountsPayable/delete',
  createAccountsPayable:
    environment.API_BASE_URL + '/v1/accountsPayable/create',
  updateAccountsPayable:
    environment.API_BASE_URL + '/v1/accountsPayable/update',
  fetchAccountsPayable: environment.API_BASE_URL + '/v1/accountsPayable/fetch/',
  addAccountsPayableGrid:
    environment.API_BASE_URL + '/v1/accountsPayable/apCharges/create',
  editAccountsPayableGrid:
    environment.API_BASE_URL + '/v1/accountsPayable/apCharges/update',
  deleteAccountsPayableGrid:
    environment.API_BASE_URL + '/v1/accountsPayable/apCharges/delete',
  validateIdentifierValue:
    environment.API_BASE_URL + '/v1/accountsPayable/validateIdentifiers/',
  apInvoiceValidate:
    environment.API_BASE_URL + '/v1/master/accountsPayable/validate',
  apInvoiceNumbers:
    environment.API_BASE_URL + '/v1/master/accountsPayable/invoiceNumbers',
  createAPcharges: environment.API_BASE_URL + '/v1/base/apCharges/create',
  updateAPcharges: environment.API_BASE_URL + '/v1/base/apCharges/update',
  deleteAPcharges: environment.API_BASE_URL + '/v1/base/apCharges/delete',
  uplaodAPInvoice:
    environment.API_BASE_URL + '/v1/accountsPayable/uploadAPCharges',
  getAllReadyForReconFileNames:
    environment.API_BASE_URL +
    '/v1/accountsPayable/getAllReadyForReconFileNames',
  publishApToGp: environment.API_BASE_URL + '/v1/accountsPayable/publishApToGp',
  processVendorRecon:
    environment.API_BASE_URL + '/v1/accountsPayable/processVendorReconn',
  validateMawbLineHaul:
    environment.API_BASE_URL +
    '/v1/accountsPayable/apCharges/validate/lineHaulCharges',

  // Accounts Receivable
  accountsReceivableBasicSearch:
    environment.API_BASE_URL + '/v1/accountsReceivable/basicSearch',
  deleteAccountsReceivable:
    environment.API_BASE_URL + '/v1/accountsReceivable/delete',
  createAccountsReceivable:
    environment.API_BASE_URL + '/v1/accountsReceivable/create',
  updateAccountsReceivable:
    environment.API_BASE_URL + '/v1/accountsReceivable/update',
  fetchAccountsReceivable:
    environment.API_BASE_URL + '/v1/accountsReceivable/fetch/',
  addAccountsReceivableGrid:
    environment.API_BASE_URL + '/v1/accountsReceivable/arCharges/create',
  editAccountsReceivableGrid:
    environment.API_BASE_URL + '/v1/accountsReceivable/arCharges/update',
  deleteAccountsReceivableGrid:
    environment.API_BASE_URL + '/v1/accountsReceivable/arCharges/delete',
  publishARToGp:
    environment.API_BASE_URL + '/v1/accountsReceivable/publishARToGP',
  arInvoiceValidate:
    environment.API_BASE_URL + '/v1/master/accountsReceivable/validate',
  validateARInvoiceNumber:
    environment.API_BASE_URL + '/v1/accountsReceivable/validateInvoiceNumber',
  validateAPInvoiceNumber:
    environment.API_BASE_URL + '/v1/accountsPayable/validateInvoiceNumber',
  getAllUnpublishedARInvoices:
    environment.API_BASE_URL +
    '/v1/accountsReceivable/getAllUnpublishedARInvoices',
  syncApChargesEligibility:
    environment.API_BASE_URL +
    '/v1/accountsReceivable/syncApCharges/eligibility',
  syncApCharges:
    environment.API_BASE_URL + '/v1/accountsReceivable/syncApCharges',
  getARChargesForInvoice:
    environment.API_BASE_URL + '/v1/accountsReceivable/addChargesToInvoice',
  sendARInvoiceViaEmail:
    environment.API_BASE_URL + '/v1/accountsReceivable/arBilling',
  masterLevelBilling:
    environment.API_BASE_URL + '/v1/accountsReceivable/masterLevelBilling',
  createARcharges: environment.API_BASE_URL + '/v1/base/arCharges/create',
  updateARcharges: environment.API_BASE_URL + '/v1/base/arCharges/update',
  deleteARcharges: environment.API_BASE_URL + '/v1/base/arCharges/delete',
  createBulkBagScanShipment:
    environment.API_BASE_URL + '/v1/bag/bulkShipment/create',
  /** Currency Convertion API */
  currencyConversionAutoSync:
    environment.API_BASE_URL + '/v1/sm/currencyConversionRates/autosync',
  deleteCurrencyConversion:
    environment.API_BASE_URL + '/v1/sm/currencyConversionRates/delete',
  updateCurrencyConversion:
    environment.API_BASE_URL + '/v1/sm/currencyConversionRates/update',
  currencyConversionBasicSearch:
    environment.API_BASE_URL + '/v1/sm/currencyConversionRates/basicSearch',
  facilitiesUsingCountry:
    environment.API_BASE_URL + '/v1/master/facilitiesUsingCountry/',

  // Alert Notifications
  fetchAlertNotifications:
    environment.API_BASE_URL + '/v1/alertNotification/fetch',
  updateAlertNotificationStatus:
    environment.API_BASE_URL + '/v1/alertNotification/status/update',
  validateServiceType: environment.API_BASE_URL + '/v1/hawb/account/',
  downloadArInvoice:
    environment.API_BASE_URL + '/v1/accountsReceivable/download/arInvoice',
  arInvoicePrintPreview:
    environment.API_BASE_URL + '/v1/accountsReceivable/arInvoice/printPreview/',
  bulkArInvoiceLoad:
    environment.API_BASE_URL + '/v1/accountsReceivable/bulk/load',
  bulkArInvoiceGenerate:
    environment.API_BASE_URL + '/v1/accountsReceivable/bulk/generate',
  arInvoicesByInvoiceDate:
    environment.API_BASE_URL + '/v1/accountsReceivable/byInvoiceDate/',

  // Dashboard
  getDashboardTypes: environment.API_BASE_URL + '/v1/dashboard/types',
  getDashboardData: environment.API_BASE_URL + '/v1/dashboard/getData',
  saveDashboardSettings: environment.API_BASE_URL + '/v1/dashboard/saveSettings',
  calculateArChargesFromApCharges:
    environment.API_BASE_URL + '/v1/dashboard/calculateArCharges',

  getReportsByReportType:
    environment.API_BASE_URL + '/v1/reports/getReportsByReportType',
} as const;
